// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__d2u7J","shimmer":"skeleton_shimmer__BXoQe"};